import { prodEnvironment } from '../../../environments/environment.prod';
import { localEnvironment } from '../../../environments/environment.local';
import { intEnvironment } from '../../../environments/environment.int';
import { edpEnvironment } from '../../../environments/environment.edp';
import { dvpEnvironment } from '../../../environments/environment.dvp';
import { mreEnvironment } from '../../../environments/environment.mre';
import { supEnvironment } from '../../../environments/environment.sup';
import { uatEnvironment } from '../../../environments/environment.uat';
import { trgEnvironment } from '../../../environments/environment.trg';
import { MockPincodeService } from '../../services/pincode/mock-pincode.service';
var Environment = /** @class */ (function () {
    function Environment() {
    }
    Environment.environmentConfig = function () {
        var env = environment[Environment.getCurrentEnvironment()];
        if (Environment.isWebVersion()) {
            env.pincodeServiceType = MockPincodeService;
            return env;
        }
        return env;
    };
    Environment.getCurrentEnvironment = function () {
        var hostname = Environment.getHostName();
        if (hostname === 'localhost') {
            return 'local';
        }
        if (hostname.split('.')[1] === 'telenet') {
            return 'prd';
        }
        return hostname.split('.')[1];
    };
    Environment.getHostName = function () {
        return window.location.hostname;
    };
    Environment.isWebVersion = function () {
        return window.location.search.includes(IS_WEB_VERSION_PARAM);
    };
    return Environment;
}());
export { Environment };
export var IS_WEB_VERSION_PARAM = 'isWebVersion=true';
export var environment = {
    prd: prodEnvironment,
    trg: trgEnvironment,
    uat: uatEnvironment,
    sup: supEnvironment,
    int: intEnvironment,
    mre: mreEnvironment,
    edp: edpEnvironment,
    dvp: dvpEnvironment,
    local: localEnvironment,
};
